var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
  'row': !_vm.full
}},[_c('div',{class:( _obj = {}, _obj[ _vm.$ALERT_COL ] = !_vm.full, _obj )},[_c('Alert',{staticClass:"alert-attention",attrs:{"title":"Your store is password protected &rarr;","icon":"IconImportant","titleLink":"reports_health"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }